<template>
	<div class="container site__block">
		<div class="row">
			<div class="col-12">
				<h1 class="text-center">
					Impressum
				</h1>
				<p><b>German Tote GmbH &amp; Co. KG</b><br>
					Rennbahnstr. 154<br>
					50737 Köln<br><br>

					Kontakt<br>
					info@germantote.de<br><br>

					Tel.: 05032 – 90140 – 0<br>
					Fax.: 05032 – 90140 – 80<br>
					<br>
					HRA 19297, Amtsgericht Köln<br>
					USt.-IdNr. DE813732795<br>
					<br>
					Vertreten durch den Geschäftsführer Riko Luiking<br>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Impressum"
	}
</script>

<style scoped>

</style>